import { useEffect } from "react";

import { ProductKeys } from "@atlassiansox/asc-stargate";

import { CrossFlowTouchpointProvider } from "@/components/cross-flow/touchpoint";
import {
    ConfluenceTemplatesUnifiedRelayPageTemplate,
    ConfluenceTemplatesUnifiedRelayPageTemplateProps
} from "@/templates/software/confluence/templates/confluence-templates-page/src/relay/contentful-relay/confluence-templates-unified-contentful-relay-page.template";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export type ConfluenceTemplatesRelayPageProps =
    ConfluenceTemplatesUnifiedRelayPageTemplateProps & {
        mlTemplateIds?: string[];
    };

export const ConfluenceTemplatesRelayPage = ({
    queryRef,
    // @ts-ignore
    mlTemplateIds
}: ConfluenceTemplatesRelayPageProps) => {
    useEffect(() => {
        checkFeatureFlagGate(featureFlags.cpapiwdConfluenceTemplateLandingGate);
    }, []);

    return (
        <CrossFlowTouchpointProvider productKeys={[ProductKeys.CONFLUENCE]}>
            <ConfluenceTemplatesUnifiedRelayPageTemplate queryRef={queryRef} />
        </CrossFlowTouchpointProvider>
    );
};
